import React, { Component } from 'react'
import { Button, Modal, Header } from '../../elements'
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  RedditShareButton,
} from 'react-share'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import './shareButton.css'
import TagManager from 'react-gtm-module'
import { compose } from 'recompose'
import withSizes from 'react-sizes'
import { MAP_SIZES_TO_PROPS } from '../../../constants'
class ShareButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      linkCopied: false,
    }
  }

  setOpen = (open) => {
    this.setState((prevState, props) => ({
      open,
    }))
  }

  handleTriggerClick = (event) => {
    this.setOpen(true)
    //TODO: Move these tags to a tracking file.
    TagManager.dataLayer({
      dataLayer: {
        event: 'fireTREvent',
        trEventCategory: 'Share Button',
        trEventAction: 'Share Button Opened',
        trEventLabel: 'Share Button - Bike Profile',
      },
    })
    this.props.onOpen()
  }

  handleClose = (event, data) => {
    this.setOpen(false)
    TagManager.dataLayer({
      dataLayer: {
        event: 'fireTREvent',
        trEventCategory: 'Share Button',
        trEventAction: 'Share Button Closed',
        trEventLabel: 'Share Button - Bike Profile',
      },
    })
  }

  buttonClick = (buttonType) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'fireTREvent',
        trEventCategory: 'Share Button Sub Item',
        trEventAction: 'Share Button Sub Item Click',
        trEventLabel: buttonType,
      },
    })
  }

  onShareWindowClose = (buttonType) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'fireTREvent',
        trEventCategory: 'Share Button Sub Item',
        trEventAction: 'Share Sub Item Modal Close',
        trEventLabel: buttonType,
      },
    })
  }

  render() {
    const {
      triggerType,
      buttonText,
      url,
      quote,
      bikePrettyID,
      isMobile,
    } = this.props
    return (
      <>
        {triggerType === 'button' && (
          <Button
            onClick={() => this.handleTriggerClick()}
            className={'has-box-shadow favorites-button'}
          >
            <i className="far fa-share-square fa-lg"></i>
          </Button>
        )}
        {triggerType === 'text' && (
          <div onClick={this.handleTriggerClick}>{buttonText}</div>
        )}
        <Modal
          show={this.state.open}
          closeOnEsc={true}
          closeOnBlur={true}
          onClose={this.handleClose}
          size="auto"
        >
          <div className="share-pop-modal">
            <Header
              renderas={'h2'}
              size={4}
              className="has-text-weight-extra-bold"
            >
              Share this motorcycle
            </Header>

            <div className="share-button-options">
              <div className="share-button-option-item">
                <FacebookShareButton
                  url={
                    url +
                    '?utm_source=facebook&utm_medium=twistedSharing&bikeID=' +
                    bikePrettyID
                  }
                  quote={quote}
                  beforeOnClick={() => this.buttonClick('facebook')}
                  onShareWindowClose={() => this.socialClosed('facebook')}
                >
                  <div className="share-button-item-title">
                    <div className="share-button-item-title-inner">
                      Facebook
                    </div>
                  </div>
                  <div className="share-button-item-icon">
                    <div className="share-button-item-icon-inner">
                      <i className="fab fa-facebook-f"></i>
                    </div>
                  </div>
                </FacebookShareButton>
              </div>
              <div className="share-button-option-item">
                <TwitterShareButton
                  url={
                    url +
                    '?utm_source=twitter&utm_medium=twistedSharing&bikeID=' +
                    bikePrettyID
                  }
                  title={quote}
                  beforeOnClick={() => this.buttonClick('twitter')}
                  onShareWindowClose={() => this.socialClosed('twitter')}
                >
                  <div className="share-button-item-title">
                    <div className="share-button-item-title-inner">Twitter</div>
                  </div>
                  <div className="share-button-item-icon">
                    <div className="share-button-item-icon-inner">
                      <i className="fab fa-twitter"></i>
                    </div>
                  </div>
                </TwitterShareButton>
              </div>
              <div className="share-button-option-item">
                <RedditShareButton
                  url={
                    url +
                    '?utm_source=reddit&utm_medium=twistedSharing&bikeID=' +
                    bikePrettyID
                  }
                  title={quote}
                  windowWidth={660}
                  windowHeight={460}
                  beforeOnClick={() => this.buttonClick('reddit')}
                  onShareWindowClose={() => this.socialClosed('reddit')}
                >
                  <div className="share-button-item-title">
                    <div className="share-button-item-title-inner">Reddit</div>
                  </div>
                  <div className="share-button-item-icon">
                    <div className="share-button-item-icon-inner">
                      <i className="fab fa-reddit-alien"></i>
                    </div>
                  </div>
                </RedditShareButton>
              </div>
              <div className="share-button-option-item">
                <EmailShareButton
                  url={
                    url +
                    '?utm_source=email&utm_medium=twistedSharing&bikeID=' +
                    bikePrettyID
                  }
                  title={quote}
                  body={
                    'Check this bike out on Twisted Road! \n' +
                    url +
                    '?utm_source=email&utm_medium=twistedSharing&bikeID=' +
                    bikePrettyID
                  }
                  beforeOnClick={() => this.buttonClick('email')}
                  onShareWindowClose={() => this.socialClosed('email')}
                >
                  <div className="share-button-item-title">
                    <div className="share-button-item-title-inner">Email</div>
                  </div>
                  <div className="share-button-item-icon">
                    <div className="share-button-item-icon-inner">
                      <i className="fal fa-envelope"></i>
                    </div>
                  </div>
                </EmailShareButton>
              </div>
              <div className="share-button-option-item">
                <CopyToClipboard
                  text={
                    url +
                    '?utm_source=copylink&utm_medium=twistedSharing&bikeID=' +
                    bikePrettyID
                  }
                  onCopy={() => {
                    this.setState({ refcopied: true })
                    this.buttonClick('copy')
                    setTimeout(() => this.setState({ refcopied: false }), 3500)
                  }}
                >
                  <span className="copy-link-wrap">
                    <div className="share-button-item-title">
                      <div className="share-button-item-title-inner">
                        {this.state.refcopied ? (
                          <span className="has-text-success">Link Copied!</span>
                        ) : (
                          <span>Copy Link</span>
                        )}
                      </div>
                    </div>
                    <div className="share-button-item-icon">
                      <div className="share-button-item-icon-inner">
                        <i className="fal fa-link"></i>
                      </div>
                    </div>
                  </span>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}

export default compose(withSizes(MAP_SIZES_TO_PROPS))(ShareButton)

ShareButton.defaultProps = {
  color: 'white', //can also be primary
  quote: 'Twisted Road',
  url: 'https://www.twistedroad.com',
  buttonText: 'Share',
  onOpen: () => {},
  triggerType: 'button', //or text
}
